(()=>{
  if(window.mtDiscoveryLoaded)return;
  window.mtDiscoveryLoaded=true;
  const instances=new Map();
  function init(root){
    root.querySelectorAll('[data-md-discovery]').forEach(section=>{
      if(instances.has(section))return;
      const buttons=[...section.querySelectorAll('[data-md-select]')];
      const panels=[...section.querySelectorAll('[data-md-panel]')];
      const listeners=[];
      const select=name=>{
        buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.mdSelect===name)));
        panels.forEach(panel=>panel.hidden=panel.dataset.mdPanel!==name);
      };
      buttons.forEach((button,index)=>{
        const click=()=>select(button.dataset.mdSelect);
        const keydown=event=>{
          if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
          event.preventDefault();
          const next=event.key==='Home'?0:event.key==='End'?buttons.length-1:(index+(event.key==='ArrowRight'?1:-1)+buttons.length)%buttons.length;
          buttons[next].focus();select(buttons[next].dataset.mdSelect);
        };
        button.addEventListener('click',click);button.addEventListener('keydown',keydown);
        listeners.push(()=>{button.removeEventListener('click',click);button.removeEventListener('keydown',keydown)});
      });
      select('coastal');
      section.querySelector('.md-choices').hidden=false;
      section.classList.add('is-ready');
      instances.set(section,()=>listeners.forEach(fn=>fn()));
    });
  }
  init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>{for(const[section,cleanup]of instances){if(event.target.contains(section)){cleanup();instances.delete(section)}}});
})();
